import { LogsFamilyEnum } from "@/model/data/enums/LogsFamilyEnum";
import { LogsTypeEnum } from "@/model/data/enums/LogsTypeEnum";

export class DownloadLogsReqData {
    installationName: string;
    machineSerialNumbers: string[] = [];
    startDate: Date;
    endDate: Date;
    daysToDownload: Date[] = [];
    logsFamily: LogsFamilyEnum;
    logTypes: LogsTypeEnum[] = [];
    ignoreMissingEntries: boolean = false;

    parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;

        if (obj.MachineSerialNumbers && obj.MachineSerialNumbers.length > 0) {
            obj.MachineSerialNumbers.forEach((m) => {
                this.machineSerialNumbers.push(m);
            });
        }

        if (obj.StartDate) this.startDate = obj.StartDate;
        if (obj.EndDate) this.endDate = obj.EndDate;

        if (obj.DaysToDownload && obj.DaysToDownload.length > 0)
            obj.DaysToDownload.forEach((element) => {
                this.daysToDownload.push(element);
            });

        if (obj.LogsFamily != null && Object.values(LogsFamilyEnum).includes(obj.LogsFamily)) this.logsFamily = obj.LogsFamily;

        if (obj.LogTypes && obj.LogTypes.length > 0) {
            obj.LogTypes.forEach((e) => {
                if (e != null && Object.values(LogsTypeEnum).includes(e)) this.logTypes.push(e);
            });
        }

        this.ignoreMissingEntries = obj.IgnoreMissingEntries;
    }
}
